/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Slug1Inputs */

const vi_cmspost_slug1 = /** @type {(inputs: Cmspost_Slug1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đường dẫn (slug)`)
};

/**

* @param {Cmspost_Slug1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_slug1 = /** @type {((inputs?: Cmspost_Slug1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Slug1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_slug1(inputs)
});
export { cmspost_slug1 as "cmsPost_slug" }